import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { AiOutlineFileProtect } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineLockReset } from 'react-icons/md';
import ConfirmDeleteModal from '../dashboard/models/ConfirmDeleteModal';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { deleteAccount } from '../../features/auth/userSlice';
const Security = () => {

    const { t } = useTranslation();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const navigate=useNavigate()
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: RootState) => state.user);
    const handleDelete = async () => {
        user?.id&& await dispatch(deleteAccount(user?.id)).unwrap()
        .then(()=>{
            navigate("/auth/login")
        })
    };
        const confirmDelete = () => {
        setDeleteModalOpen(true);
    };
    return (
        <div>
            <h3 className=' text-xl mb-4 font-semibold'>{t("security")}</h3>
            <div>
                <Link to={"/me/terms-of-use"} className='border rounded-xl flex justify-between p-3 pb-14 text-textSecond'>
                    <p>{t("terms-of-use")}</p>
                    <AiOutlineFileProtect />
                </Link>
                <div className=' flex xs:flex-col sm:flex-row pt-5 gap-5'>
                    <button onClick={() => confirmDelete()} className=' text-white bg-red-600 rounded-lg w-full p-2 flex-center gap-1'>
                        <p>{t("delete-account")}</p>
                        <RiDeleteBin6Line />
                    </button>
                    <button onClick={()=>navigate("reset-password")} className=' text-white bg-primary rounded-lg w-full p-2 flex-center gap-1'>
                        <p>{t("reset-password")}</p>
                        <MdOutlineLockReset />
                    </button>
                </div>
            </div>
            <ConfirmDeleteModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDelete}
                messageKey="delete-account-confirm"
            />
        </div>
    )
}

export default Security